import { render, staticRenderFns } from "./TaxReturnDeductiblesSection.vue?vue&type=template&id=6c350dc0&scoped=true&"
import script from "./TaxReturnDeductiblesSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnDeductiblesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c350dc0",
  null
  
)

export default component.exports